// Tour launcher panel (opened by the nav footer button) — prefix `tlp-`.
// Aggregated into componentStyles.
export const tourLauncherStyles = `
  .tlp-root {
    display: flex;
    flex-direction: column;
    gap: var(--space-5);
    /* Rendered in a portaled modal, so set the app font explicitly. */
    font-family: var(--font-sans);
  }

  /* Hero strip */
  .tlp-hero {
    display: flex;
    align-items: center;
    gap: var(--space-4);
    padding: var(--space-4) var(--space-5);
    border-radius: var(--rad-catchup-large);
    background: linear-gradient(
      135deg,
      var(--brand-50, rgba(87, 194, 211, 0.16)) 0%,
      rgba(126, 87, 194, 0.12) 100%
    );
    border: 1px solid var(--glass-border);
  }
  .tlp-hero-text {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }
  .tlp-hero-title {
    font-size: var(--fs-lg);
    font-weight: var(--font-weight-bold);
    color: var(--brand-dark);
  }
  .tlp-hero-sub {
    font-size: var(--fs-sm);
    line-height: var(--leading-base);
    color: var(--catchup-gray-500);
  }

  /* Tour cards — two columns on wide modals, single column when narrow */
  .tlp-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--space-3);
  }
  .tlp-card {
    display: flex;
    align-items: center;
    gap: var(--space-4);
  }

  @media (max-width: 720px) {
    .tlp-list { grid-template-columns: minmax(0, 1fr); }
  }
  .tlp-card-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 46px;
    height: 46px;
    flex-shrink: 0;
    border-radius: var(--rad-catchup-medium);
    background: var(--accent-purple-bg, rgba(126, 87, 194, 0.12));
    color: var(--catchup-blue);
  }
  .tlp-card-text {
    display: flex;
    flex-direction: column;
    gap: 3px;
    flex: 1;
    min-width: 0;
  }
  .tlp-card-title {
    font-size: var(--fs-md);
    font-weight: var(--font-weight-bold);
    color: var(--brand-dark);
  }
  .tlp-card-desc {
    font-size: var(--fs-sm);
    line-height: var(--leading-base);
    color: var(--catchup-gray-500);
  }
  .tlp-card-meta {
    display: flex;
    align-items: center;
    gap: var(--space-2);
    margin-top: 2px;
    font-size: var(--fs-xs, var(--fs-sm));
    color: var(--catchup-gray-400);
  }
  .tlp-meta-item {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }
  .tlp-meta-dot {
    width: 3px;
    height: 3px;
    border-radius: var(--rad-catchup-full);
    background: var(--catchup-gray-200);
  }
  .tlp-card-cta {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
    padding: var(--space-2) var(--space-4);
    border-radius: var(--rad-catchup-full);
    background: var(--catchup-blue);
    color: var(--catchup-white);
    font-size: var(--fs-sm);
    font-weight: 600;
  }

  @media (max-width: 460px) {
    .tlp-card-cta-label { display: none; }
    .tlp-card-cta { padding: var(--space-2); }
  }
`;
